import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Helmet } from 'react-helmet';
import useProject from 'utils/hooks/useProjectSelect';
import withProjectParams from 'utils/hocs/withProjectParams';
import { getHasFlowEnabled } from 'store/services/project/selectors';
import Chat from '../../scenes/Bounder/components/Chat';

const mapStateToProps = state => ({
  hasFlowEnabled: getHasFlowEnabled(state),
});

const isSettingsUrl = url => {
  const path = url.split('/')[3];

  const isSettingsPage = path === 'project-settings' || path === 'chat-logs';
  const isSetupPage = url.split('/')[4] === 'application-setup';

  return isSettingsPage || isSetupPage;
};

const isResolveConflictsUrl = url => {
  const path = url.split('/')[3] || '';

  return path === 'resolve-conflicts';
};

const ProjectWrapper = compose(
  withProjectParams,
  connect(mapStateToProps),
)(props => {
  const {
    company,
    project,
    dispatch,
    children,
    hasFlowEnabled,
    location,
  } = props;

  useProject({ project, company }, dispatch);

  const { pathname } = location;

  const showChat = () =>
    hasFlowEnabled &&
    !isSettingsUrl(pathname) &&
    !isResolveConflictsUrl(pathname);

  return (
    <>
      <Helmet>
        <title>Omilia Conversation Studio</title>
      </Helmet>

      {children}
      {showChat() && <Chat />}
    </>
  );
});

export default ProjectWrapper;
